import { Box, Dialog, styled } from "@mui/material";
import { colors } from '../../../theme/colors';

export const HomeContainer = styled(Box)(() => {
  return {
    background: "linear-gradient(135deg, #fef6f6 0%, #f8f9fb 100%)",
    minHeight: "100%",
    padding: "28px",

    "& .page-header": {
      marginBottom: "24px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "16px",
    },

    "& .step-flow": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      background: "#ffffff",
      borderRadius: "16px",
      padding: "16px 24px",
      marginBottom: "24px",
      border: `1px solid ${colors.border.light}`,
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
      flexWrap: "nowrap",
      overflowX: "auto",
    },

    "& .step-flow__step": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "10px 18px",
      borderRadius: "999px",
      minWidth: "auto",
      transition: "all 0.25s ease",
      boxSizing: "border-box",
      flexShrink: 0,
    },

    "& .step-flow__number": {
      width: "28px",
      height: "28px",
      minWidth: "28px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 700,
      fontSize: "13px",
      lineHeight: 1,
    },

    "& .step-flow__title": {
      fontWeight: 700,
      fontSize: "13.5px",
      lineHeight: 1.2,
      marginBottom: "2px",
    },

    "& .step-flow__subtitle": {
      fontSize: "11.5px",
      lineHeight: 1.2,
    },

    "& .step-flow__connector": {
      flex: 1,
      height: "2px",
      background: "#e2e8f0",
      borderRadius: "999px",
      minWidth: "30px",
      maxWidth: "70px",
    },

    "& .step-flow__connector--done": {
      background: colors.primary,
    },

    "& .step-flow__step--done": {
      background: colors.primaryLight,
      border: `1px solid ${colors.primaryLightBorder}`,
      "& .step-flow__number": {
        backgroundColor: colors.primary,
        color: "#fff",
      },
      "& .step-flow__title": {
        color: colors.primary,
      },
      "& .step-flow__subtitle": {
        color: colors.secondary,
      },
    },

    "& .step-flow__step--active": {
      background: colors.primary,
      boxShadow: "0 8px 20px rgba(127, 29, 29, 0.22)",
      "& .step-flow__number": {
        backgroundColor: "#fff",
        color: colors.primary,
      },
      "& .step-flow__title": {
        color: "#fff",
      },
      "& .step-flow__subtitle": {
        color: "#fecdd3",
      },
    },

    "& .step-flow__step--pending": {
      background: "#f8fafc",
      border: "1px solid #e2e8f0",
      "& .step-flow__number": {
        backgroundColor: "#cbd5e1",
        color: "#64748b",
      },
      "& .step-flow__title": {
        color: "#64748b",
      },
      "& .step-flow__subtitle": {
        color: "#94a3b8",
      },
    },

    "@media (max-width: 900px)": {
      "& .step-flow": {
        flexDirection: "column",
        alignItems: "stretch",
        padding: "14px",
        overflowX: "hidden",
      },

      "& .step-flow__step": {
        width: "100%",
        minWidth: "unset",
      },

      "& .step-flow__connector": {
        width: "2px",
        height: "16px",
        minWidth: "2px",
        maxWidth: "unset",
        alignSelf: "center",
      },
    },

    "& .resume-list-wrapper": {
      marginTop: "16px",
      maxHeight: "130px",
      overflowY: "auto",
      overflowX: "hidden",
      paddingRight: "6px",
      borderRadius: "10px",
    },

    "& .resume-list-wrapper::-webkit-scrollbar": {
      width: "6px",
    },

    "& .resume-list-wrapper::-webkit-scrollbar-track": {
      background: "#f1f5f9",
      borderRadius: "10px",
    },

    "& .resume-list-wrapper::-webkit-scrollbar-thumb": {
      backgroundColor: colors.primary,
      borderRadius: "10px",
    },

    "& .upload-sections": {
      display: "flex",
      gap: "24px",
      marginBottom: "20px",
      alignItems: "stretch",
      "@media (max-width: 900px)": {
        flexDirection: "column",
      },
    },

    "& .upload-card": {
      flex: 1,
      background: "#ffffff",
      border: `1px solid ${colors.border.light}`,
      borderRadius: "16px",
      padding: "28px",
      boxSizing: "border-box",
      minWidth: 0,
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.03)",
      transition: "all 0.25s ease",
      "&:hover": {
        boxShadow: "0 10px 30px rgba(127, 29, 29, 0.06)",
        borderColor: colors.primaryLightBorder,
      },
    },

    "& .upload-card__header": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      marginBottom: "8px",
    },

    "& .upload-card__heading": {
      fontWeight: 700,
      fontSize: "17px",
      color: colors.black,
    },

    "& .upload-card__desc": {
      fontSize: "13.5px",
      color: colors.text.secondary,
      marginBottom: "18px",
      textAlign: "center",
    },

    "& .dropzone": {
      border: `2px dashed ${colors.primaryLightBorder}`,
      borderRadius: "14px",
      padding: "24px 20px",
      boxSizing: "border-box",
      width: "100%",
      maxWidth: "340px",
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      backgroundColor: colors.primaryLight,
      transition: "all 0.25s ease",
      flexShrink: 0,
      "&:hover": {
        backgroundColor: "#fde8e8",
        borderColor: colors.primary,
        transform: "translateY(-2px)",
      },
      "& .input__pdf": {
        display: "none",
      },
    },

    "& .dropzone--resume": {
      borderColor: colors.primaryLightBorder,
      backgroundColor: colors.primaryLight,
      marginTop: "57px",
      "&:hover": {
        backgroundColor: "#fde8e8",
        borderColor: colors.primary,
      },
    },

    "& .dropzone__text": {
      fontWeight: 700,
      fontSize: "14.5px",
      color: colors.primary,
      marginTop: "8px",
    },

    "& .dropzone__hint": {
      fontSize: "12px",
      color: colors.text.muted,
      marginBottom: "12px",
    },

    "& .upload-btn": {
      backgroundColor: colors.primary,
      color: "#fff",
      borderRadius: "999px",
      textTransform: "none",
      fontWeight: 600,
      padding: "7px 24px",
      fontSize: "13.5px",
      boxShadow: "0 4px 12px rgba(127, 29, 29, 0.2)",
      "&:hover": {
        backgroundColor: colors.primaryHover,
        boxShadow: "0 6px 16px rgba(127, 29, 29, 0.3)",
      },
    },

    "& .upload-btn--resume": {
      backgroundColor: colors.primary,
      "&:hover": {
        backgroundColor: colors.primaryHover,
      },
    },

    "& .action-bar": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "28px",
      marginBottom: "28px",
    },

    "& .submit-btn": {
      background: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
      color: "#fff",
      borderRadius: "14px",
      textTransform: "none",
      fontWeight: 700,
      padding: "14px 64px",
      fontSize: "16.5px",
      minWidth: "360px",
      boxShadow: "0 8px 24px rgba(127, 29, 29, 0.25)",
      transition: "all 0.5s cubic-bezier(0.4, 0, 0.2, 1) !important",
      position: "relative",
      overflow: "hidden",
      zIndex: 1,
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(135deg, ${colors.primaryHover} 0%, #3a0606 100%)`,
        opacity: 0,
        transition: "opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
        zIndex: -1,
      },
      "&:hover": {
        boxShadow: "0 12px 32px rgba(127, 29, 29, 0.4)",
        transform: "translateY(-3px)",
        "&::before": {
          opacity: 1,
        },
      },
    },

    "& .JD__filename": {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "100%",
    },

    "& .btn": {
      display: "block",
      backgroundColor: colors.primary,
      color: "#fff",
      borderRadius: "10px",
      margin: "10px 0px",
      textTransform: "none",
      fontWeight: 600,
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: colors.primaryHover,
        boxShadow: "0 4px 12px rgba(127, 29, 29, 0.2)",
      },
    },

    "& .download_btn": {
      padding: "8px 16px",
      borderRadius: "10px",
      backgroundColor: colors.primary,
      color: "#fff",
      textTransform: "none",
      fontWeight: 600,
      transition: "all 0.2s ease",
      boxShadow: "0 4px 12px rgba(127, 29, 29, 0.15)",
      "&:hover": {
        backgroundColor: colors.primaryHover,
        boxShadow: "0 6px 16px rgba(127, 29, 29, 0.25)",
      },
    },

    "& .MuiAccordionSummary-expandIconWrapper": {
      color: "#fff",
    },

    "& .MuiTableCell-head": {
      fontSize: "13px",
      fontWeight: 700,
      color: "#fff !important",
      whiteSpace: "nowrap",
      backgroundColor: colors.primary,
      backgroundImage: `linear-gradient(135deg, ${colors.primary} 0%, ${colors.secondary} 100%)`,
      letterSpacing: "0.4px",
      padding: "14px 16px",
    },

    "& .MuiTableBody-root .MuiTableRow-root": {
      "&:nth-of-type(even)": {
        backgroundColor: "#fafafa",
      },
      "&:hover": {
        backgroundColor: colors.primaryLight,
      },
      transition: "background-color 0.15s ease",
    },

    "& .MuiTableBody-root .MuiTableCell-root": {
      fontSize: "13px",
      padding: "12px 14px",
      verticalAlign: "middle",
      borderBottom: "1px solid #eef2f6",
    },

    "& .custom-scrollbar": {
      marginBottom: "24px",
      borderRadius: "16px",
      border: `1px solid ${colors.border.light}`,
      overflowX: "auto",
      overflowY: "auto",
      boxShadow: "0 6px 24px rgba(0, 0, 0, 0.04)",
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f5f9",
      },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: colors.primary,
        borderRadius: "10px",
      },
    },
  };
});

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1.5, 3),
  },
  "& .MuiPaper-root": {
    borderRadius: 16,
  },
}));
